interface PartyLabelInput {
  company?: string | null;
  name?: string | null;
  phone?: string | null;
  /** Primary label when there is neither a company nor a name. */
  fallback?: string;
}

/**
 * How the console names a partner or shipper: the company is the main label
 * with "Name · phone" under it; without a company the name leads and the
 * phone sits under it.
 */
export function partyLabel({ company, name, phone, fallback = '' }: PartyLabelInput) {
  const c = company?.trim();
  const n = name?.trim();
  const p = phone?.trim();
  if (c) {
    return { primary: c, secondary: [n, p].filter(Boolean).join(' · ') };
  }
  return { primary: n || fallback, secondary: p ?? '' };
}

/**
 * The one name rule for a console user (list, drawer, profile): the company is
 * the headline with the contact person beneath it; without a company the name
 * leads; with neither, "No name". Drivers never have a company.
 */
export function userDisplayName(user: { companyName?: string | null; fullName?: string | null }) {
  const { primary } = partyLabel({ company: user.companyName, name: user.fullName, fallback: 'No name' });
  const hasCompany = Boolean(user.companyName?.trim());
  return { headline: primary, secondary: hasCompany ? user.fullName?.trim() || null : null };
}
